function updateTotal(){
  var amount = parseInt($('#amount-credit').val());

  console.log(amount);

  if (!amount || amount < 0)
      return;
    var price = 15;
    var total = (price * amount).toFixed(2);
  $('.top-up-credit-total-value').text(total);
}

$('#amount-credit').on('input', updateTotal);

$('.js-form-amount-credit__input-btn').on('click', function(e) {
  e.preventDefault()
  e.stopPropagation();
  updateTotal();
});

$(document).ready(function () {
  function renderSelect2() {
    let countrySelect = $(document).find('.js-country-select')
    if (countrySelect.length) {
      countrySelect.select2({
        placeholder: "United Kingdom",
        minimumResultsForSearch: -1
      })
    }
  }

  function init() {
    updateTotal()
    renderSelect2()
  }

  init()
})